import React, { lazy, Suspense } from "react";
import useGlobalApis from "@/apis/global";
import useFilter from "@/hooks/useFilter";
import Layout from "@/layout/DefaultLayout";
import { useQuery } from "@tanstack/react-query";
import LazyLoader from "@/components/LazyLoader";
const Preview = lazy(() => import("@/components/Preview/Preview"));
const Events = () => {
  const { filterOption } = useFilter({
    query: {
      sectionStatus: "publish",
    },
  });
  const { getFeed } = useGlobalApis();
  const feed = useQuery({
    queryKey: ["bussines-feed", filterOption],
    queryFn: () =>
      getFeed({
        params: filterOption,
        type: "events",
      }),
  });
  return (
    <Layout viewMobTopNav={true}>
      <Suspense fallback={<LazyLoader />}>
        <Preview
          data={feed.data?.data}
          type="events"
          isLoading={feed.isLoading}
        />
      </Suspense>
    </Layout>
  );
};

export default Events;
